import { PlantInfosData, ChargeExploitationData } from '../../domain/plantInfos.types'
import { useFetchApi } from '../../adapter/fetchApi'

export const usePlantInfosApi = () => {
  const fetchApi = useFetchApi()
  return {
    getPlantInfos: async (centraleId: number): Promise<PlantInfosData> => {
      const url = `/centrales/${centraleId}/infos`
      const plantInfoData = await fetchApi<PlantInfosData>(url)
      const isPlantInfosData = (data: unknown): data is PlantInfosData => !!data
      if (!plantInfoData || !isPlantInfosData(plantInfoData)) {
        throw new Error(`usePlantInfosApi.getPlantInfos - Error : ${plantInfoData}`)
      }
      return plantInfoData
    },

    getChargeExploitation: async (mail: string): Promise<ChargeExploitationData> => {
      const url = `charges-exploitation/${mail}`
      const chargeExploitationData = await fetchApi<ChargeExploitationData>(url)
      const isChargeExploitationData = (data: unknown): data is ChargeExploitationData => !!data
      if (!chargeExploitationData || !isChargeExploitationData(chargeExploitationData)) {
        throw new Error(
          `usePlantInfosApi.getChargeExploitation - Error : ${chargeExploitationData}`
        )
      }
      return chargeExploitationData
    },
  }
}
